export default class ValidateDefaults {
    constructor(obj) {
        this.isValid = true;
        this.message = obj.message ? obj.message : this.constructor.defaultMessage();
        this.on = ['blur'];
        this.multipleMessages = false;
        this.pageAttrKey = '';
        this.formData = '';
        // this.name = (obj.name) ? obj.name : (function(){
        //     console.warn('Please pass in the name.');
        // })();
    }

    getIsValid() {
        return this.isValid;
    }

    setIsValid(bool) {
        this.isValid = bool;
        return this;
    }

    getMessage(on) {
        if (typeof on === 'string' && this.on.indexOf(on) === -1) {
            return null;
        }

        if (typeof this.message === 'function') {
            return this.message();
        } else {
            return this.message ? this.message : this.constructor.defaultMessage();
        }
    }

    getMatchingValidationMessage(validationKey, validations) {}

    setMessage(msg) {
        this.message = msg;
        return this;
    }

    error(msg) {
        this.setIsValid(false).setMessage(msg);
        return this;
    }

    getError() {
        return this.message;
    }

    validate() {}

    setFormData(dat) {
        this.formData = dat;
    }

    static isEmpty(value) {
        return !value || (typeof value === 'string' && value.trim().length === 0);
    }

    static defaultMessage() {
        return '';
    }
}
